interface MediaEmbedProps {
  type: 'youtube' | 'spotify' | 'apple' | 'custom'
  videoId?: string
  spotifyUri?: string
  applePodcastId?: string
  appleEpisodeId?: string
  embedHtml?: string
  title?: string
}

export default function MediaEmbed({
  type,
  videoId,
  spotifyUri,
  applePodcastId,
  appleEpisodeId,
  embedHtml,
  title = 'Media embed',
}: MediaEmbedProps) {
  if (type === 'apple' && applePodcastId && appleEpisodeId) {
    const embedUrl = `https://embed.podcasts.apple.com/podcast/id${applePodcastId}?i=${appleEpisodeId}&theme=dark`
    return (
      <div className="w-full bg-archive-slate rounded-lg overflow-hidden">
        <iframe
          src={embedUrl}
          title={title}
          allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
          sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
          loading="lazy"
          className="w-full h-[175px]"
          style={{ colorScheme: 'dark' }}
        />
      </div>
    )
  }

  if (type === 'youtube' && videoId) {
    return (
      <div className="relative aspect-video w-full bg-archive-slate rounded-lg overflow-hidden">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
          loading="lazy"
        />
      </div>
    )
  }

  if (type === 'spotify' && spotifyUri) {
    // Convert spotify:episode:xxx to embed URL
    const embedUrl = spotifyUri.startsWith('spotify:')
      ? `https://open.spotify.com/embed/${spotifyUri.replace('spotify:', '').replace(/:/g, '/')}`
      : spotifyUri

    return (
      <div className="w-full bg-archive-slate rounded-lg overflow-hidden">
        <iframe
          src={embedUrl}
          title={title}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          className="w-full h-[152px]"
        />
      </div>
    )
  }

  if (type === 'custom' && embedHtml) {
    return (
      <div
        className="w-full bg-archive-slate rounded-lg overflow-hidden"
        dangerouslySetInnerHTML={{ __html: embedHtml }}
      />
    )
  }

  return null
}
